const GreffierMesureRemoveStyle = {
  bg: "white",
  flexWrap: "wrap",
  width: "100%",
};

export { GreffierMesureRemoveStyle };
